import {
    Injectable
}
from '@angular/core';
import {
    Store
}
from '@ngrx/store';
import {
    AppState
}
from '../app.state';
import { Observable } from 'rxjs';
import { GameSettingsState } from './gameSettings.state';


@Injectable()
export class GameSettingsDispatcher {


    constructor(
        private store: Store < AppState > ,
    ) {}


    /** Returns an Observable of non-null GameStates */
    public getState(): Observable < GameSettingsState > {
        return this.store.select((state: AppState) => state.gameSettings);
    }

    public getStatsUI(): Observable <string | null> {
        return this.store.select((state: AppState) => state.gameSettings.showStatsUI);
    }
}
